import { z } from "zod";

export const GetCheckPdfSchema = z.object({
  paystub_id: z.string(),
});

export type IGetCheckPDFRequestBody = z.infer<typeof GetCheckPdfSchema>;
export type IGetCheckPDFResponseData = string;
